/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plant_Real_Tree_For_EarthInputs */

const en_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plant for the Earth`)
};

const ar_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ازرع من أجل الأرض!`)
};

const de_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pflanzen für die Erde`)
};

const es_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plantar para la Tierra`)
};

const fr_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Planter pour la Terre`)
};

const it_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pianta per la Terra`)
};

const ja_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`地球のための植樹`)
};

const ko_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`지구를 위해 나무 심기`)
};

const pt_br_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plante pela Terra`)
};

const ru_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Посадка для Земли`)
};

const th_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลูกต้นไม้ให้กับโลก`)
};

const tr_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dünya için Ağaç Dik`)
};

const zh_cn_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为地球种树`)
};

const zh_tw_plant_real_tree_for_earth = /** @type {(inputs: Plant_Real_Tree_For_EarthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為地球種樹`)
};

/**
* | output |
* | --- |
* | "Plant for the Earth" |
*
* @param {Plant_Real_Tree_For_EarthInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const plant_real_tree_for_earth = /** @type {((inputs?: Plant_Real_Tree_For_EarthInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plant_Real_Tree_For_EarthInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_plant_real_tree_for_earth(inputs)
	if (locale === "ar") return ar_plant_real_tree_for_earth(inputs)
	if (locale === "de") return de_plant_real_tree_for_earth(inputs)
	if (locale === "es") return es_plant_real_tree_for_earth(inputs)
	if (locale === "fr") return fr_plant_real_tree_for_earth(inputs)
	if (locale === "it") return it_plant_real_tree_for_earth(inputs)
	if (locale === "ja") return ja_plant_real_tree_for_earth(inputs)
	if (locale === "ko") return ko_plant_real_tree_for_earth(inputs)
	if (locale === "pt_br") return pt_br_plant_real_tree_for_earth(inputs)
	if (locale === "ru") return ru_plant_real_tree_for_earth(inputs)
	if (locale === "th") return th_plant_real_tree_for_earth(inputs)
	if (locale === "tr") return tr_plant_real_tree_for_earth(inputs)
	if (locale === "zh_cn") return zh_cn_plant_real_tree_for_earth(inputs)
	return zh_tw_plant_real_tree_for_earth(inputs)
});